import React from "react";
import DynamicForm from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import { PageLoading } from "../../ui/PageLoading";
import { useResetPasswordView } from "./useResetPasswordView";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import { useTranslation } from "react-i18next";
import { Title } from "../util/Title";
import { useGenerateResetPasswordForm } from "./useGenerateResetPasswordForm";

export function ResetPasswordView () {
  const { resetPassword, isLoading, isParamsReady} = useResetPasswordView();
  const { formRows, oneTimeCode } = useGenerateResetPasswordForm();
  const { t } = useTranslation();

  if(isParamsReady) return <PageLoading/>

  return (
    <>
      <Title title={t("forms.forgotPassword.Texts.chooseNewPassword")} subTitle= {t("forms.forgotPassword.Texts.chooseNewPasswordSubtext")}/>
      <DynamicForm
        formData={{}}
        formRows={formRows}
        spacing="1.5rem"
        formKeyName="test form"
        onHandleSubmit={(data) =>
          resetPassword({ ...data, code: oneTimeCode.toString() } as any) 
        }
        useFormOptions={{
          mode: "onBlur",
          reValidateMode: "onChange",
        }}
        formButtons={{
          leftButton: {
            type: "submit",
            label: t("forms.resetPassword.submit"),
            color: EColourPanel.PRIMARY,
            fullWidth: true,
            disabled: isLoading,
          },
        }}
      />
    </>
  );
};
